<template>
  <div class="catalog-sort-modal">
    <ModalComponentHeader> {{ messages?.sort }} </ModalComponentHeader>
    <ModalComponentBody>
      <DefRadio
        v-for="item in items"
        :checked="item.active || (!getActiveItem && item.sort === 'property_POPULAR')"
      >
        <a :href="item.request" rel="nofollow" @click.prevent="handlerChangeSort(item)">
          {{ item.name }}
        </a>
      </DefRadio>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import { useStore } from '@/store';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import DefRadio from '@components/Def/DefRadio/DefRadio.vue';

const router = useRouter();

const { state, dispatch } = useStore();

const messages = computed(() => state.catalog.data?.catalogSort?.messages);
const items = computed(() => state.catalog.data?.catalogSort?.items);

const handlerChangeSort = (item) => {
  router.replace(item.request);
  dispatch('catalog/changePageData', item.request);
};

const getActiveItem = computed(() => items.value.find((el) => el.active));
</script>

<style lang="scss" scoped>
.catalog-sort-modal {
  :deep(.modal-component-body) {
    display: grid;
    grid-row-gap: 24px;
  }
}
</style>
